import { QUERY_KEYS } from 'api/query-keys';
import { partnerUserService } from 'hq/services';
import { useQuery } from 'react-query';
import { CACHE_TIME_LONG, STALE_TIME_LONG } from 'shared/react-query/query-defaults';

const useGetPartnerUser = (userId: string) => {
  const queryFn = async () => await partnerUserService.getUser(userId);

  return useQuery(QUERY_KEYS.partnerUser(userId), {
    queryFn,
    cacheTime: CACHE_TIME_LONG,
    staleTime: STALE_TIME_LONG,
  });
};

export { useGetPartnerUser };
